import { SupportedRegions } from '@rbi-ctg/frontend';

export interface IUsePrepaidsBalanceProps {
  region: SupportedRegions;
}
